import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

const staticEntryEditSearchSchema = z.object({
  wiid: z.coerce.number(),
});

export type StaticEntryEditSearch = z.infer<typeof staticEntryEditSearchSchema>;

export const Route = createFileRoute("/static-entry/edit/$type/$id")({
  validateSearch: staticEntryEditSearchSchema,
});
